var map = {
	"./button-group.yaml": "6154",
	"./button.yaml": "2a79",
	"./index.yaml": "5c8c",
	"./list.yaml": "4036",
	"./progress.yaml": "3f7f",
	"./select.yaml": "2f2b",
	"./slider.yaml": "9379",
	"./text-input.yaml": "8285",
	"./toggle.yaml": "789c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e9e1";